var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { addToWaitlist } from '../firebase/waitlist';
import { tw } from '../utils/tw';
var moodOptions = [
    { value: 'tired', label: 'Mentally tired' },
    { value: 'restless', label: 'Restless' },
    { value: 'curious', label: 'Curious' },
    { value: 'creative', label: 'Creative' },
];
var WaitlistForm = function () {
    var _a = useState(''), email = _a[0], setEmail = _a[1];
    var _b = useState(''), mood = _b[0], setMood = _b[1];
    var _c = useState('idle'), status = _c[0], setStatus = _c[1];
    var _d = useState(''), errorMessage = _d[0], setErrorMessage = _d[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!email) {
                        setErrorMessage('Please enter your email address');
                        return [2 /*return*/];
                    }
                    setStatus('loading');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, addToWaitlist({ email: email, mood: mood })];
                case 2:
                    result = _a.sent();
                    if (result.success) {
                        setStatus('success');
                        setEmail('');
                        setMood('');
                        setErrorMessage('');
                    }
                    else {
                        throw new Error('Failed to join waitlist');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setStatus('error');
                    setErrorMessage('Something went wrong. Please try again later.');
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: tw.card, id: "waitlist", children: [_jsx("h3", { className: "".concat(tw.headingMd, " mb-6"), children: "Join the Waitlist" }), status === 'success' ? (_jsxs("div", { className: "bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3", children: [_jsx("div", { className: "bg-green-100 p-2 rounded-full", children: _jsx(Check, { size: 20, className: "text-green-600" }) }), _jsxs("div", { children: [_jsx("h4", { className: "font-medium text-green-800", children: "You're on the list! \uD83C\uDF89" }), _jsx("p", { className: "text-sm text-green-600", children: "We'll let you know when BoredGenie is ready." })] })] })) : (_jsxs("form", { onSubmit: handleSubmit, className: "space-y-4", children: [_jsxs("div", { children: [_jsx("label", { htmlFor: "email", className: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1", children: "Email address" }), _jsx("input", { type: "email", id: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, placeholder: "you@example.com", className: "w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all", required: true })] }), _jsxs("div", { children: [_jsx("label", { htmlFor: "mood", className: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1", children: "How do you usually feel when bored? (optional)" }), _jsxs("select", { id: "mood", value: mood, onChange: function (e) { return setMood(e.target.value); }, className: "w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all", children: [_jsx("option", { value: "", children: "Select an option" }), moodOptions.map(function (option) { return (_jsx("option", { value: option.value, children: option.label }, option.value)); })] })] }), errorMessage && (_jsx("div", { className: "text-red-600 text-sm", children: errorMessage })), _jsx("button", { type: "submit", disabled: status === 'loading', className: "".concat(tw.btnPrimary, " w-full flex items-center justify-center gap-2"), children: status === 'loading' ? (_jsxs(_Fragment, { children: [_jsx(Loader2, { size: 20, className: "animate-spin" }), _jsx("span", { children: "Joining..." })] })) : (_jsx("span", { children: "Join Waitlist" })) }), _jsx("p", { className: "text-xs text-slate-500 dark:text-slate-400 text-center", children: "We respect your privacy and will never share your email." })] }))] }));
};
export default WaitlistForm;
